import { atom } from 'recoil';
import { ReportFiltersState } from '../../types/navigation';


export const initialReportFiltersState: ReportFiltersState = {
  nameSearchString: '',
  selectedUsers: [],
  selectedReportTypes: [],
  selectedMinimumOverallRating: [],
};


export const reportFiltersState = atom<ReportFiltersState>({
  key: 'reportFilters',
  default: initialReportFiltersState,
});
